var React = require('react');

function PricingSquiggleMobileInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.5","d":"M97.75 1.25C92.6827 2.90517 88.7006 6.59189 84.0494 9.09868C71.9022 15.6454 59.958 17.2171 46.615 20.1695C35.9179 22.5364 21.6414 23.6712 15.209 33.8014C12.1808 38.5704 10.6369 43.8041 8.21113 48.8378C5.55101 54.3578 4.12039 58.5633 1 62","stroke":"#DCE3DD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

PricingSquiggleMobileInline.defaultProps = {"width":"99","height":"63","viewBox":"0 0 99 63","fill":"none"};

module.exports = PricingSquiggleMobileInline;

PricingSquiggleMobileInline.default = PricingSquiggleMobileInline;
